import Component from './Component';
import React from 'react';

export default class RequiredSymbol extends Component {

	static contextTypes = {
		form: React.PropTypes.object
	};

	render() {
		const schema = this.context.form.schema;

		return (
			<span style={{color: '#A00'}}>*</span>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/RequiredSymbol.js